import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { Tooltip, Badge, Progress, notification } from 'antd'
import { hideComment } from '../../actions/CommentAction'
import { setSelectExpandAsset } from '../../actions/ClientAction'
import CollectionItemFullScreenV2 from '../collection/CollectionItemFullScreenV2'
export class RightButtons extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isShowViewFile: false
    }
  }
  
  expandAsset = (keyCollection, itemSelected) => {
    const { originalURL, type, name } = itemSelected
    const { intl } = this.props
    const now = Date.now()
    const confinNotf = {
      message: intl.formatMessage({ id: "opening_pdf" }),
      description: <Progress percent={100} status="active" />,
      key: now.toString()
    }
    if (originalURL) {
      const ext =
        originalURL
          .split('.')
          .slice(-1)[0]
          .toLowerCase() || null
      if (ext && ext === 'pdf' && type === 'document') {
        notification.open(confinNotf)
        fetch(originalURL)
          .then(res => res.blob())
          .then(blob => {
            const newBlob = blob.slice(0, blob.size, 'application/pdf')
            const objectURL = URL.createObjectURL(newBlob)
            window.open(objectURL, name, '_blank')
            notification.close(now.toString())
          });
      }
      else {
        
        this.setState({
          isShowViewFile: true
        })
      }
    }
  }
  showOrHideViewsFull = isViewF => {
    this.setState({
      isShowViewFile: isViewF ? false : true
    })
  }
  render() {
    const hash = '#'
    const {
      isShowComments,
      isShowCompareVersion,
      isShowVersions,
      // isShowFiles,
      // isShowView,
      // isShowCopy,
      // isShowPage,
      shouldShowVersionsButton,
      intl,
      // info,
      itemSelected,
      fromKeyCollection
    } = this.props
    const { isShowViewFile } = this.state;

    return (
      <React.Fragment>
        <div
          className="bb-archives-block__buttons"
          style={{
            display: 'flex',
            position: 'absolute',
            width: 330,
            top: 46,
            left: 40,
            alignItems: 'center',
          }}
        >
          {/* <Tooltip placement="bottom" title="Archivos">
            <div
              onClick={() => this.props.showOrHideViews(0)}
              className={isShowFiles ? 'active' : ''}
            >
              <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M23.7803 11.2589C22.9216 11.246 22.0623 11.256 21.1737 11.256C20.8689 9.33589 20.0566 7.67827 18.6887 6.31013C17.3214 4.94258 15.6645 4.12874 13.7457 3.82693C13.7457 3.00487 13.7486 2.21452 13.7434 1.42358C13.7422 1.24919 13.7404 1.06775 13.6958 0.901572C13.5319 0.296185 12.9698 -0.0625853 12.3273 0.0090512C11.7458 0.0736415 11.2736 0.575097 11.2613 1.18283C11.2449 1.97377 11.2484 2.76588 11.259 3.55682C11.2619 3.76116 11.2043 3.83984 10.9976 3.8833C7.31326 4.65662 4.97274 6.86326 3.98133 10.4962C3.91496 10.7393 3.87267 10.9888 3.8157 11.2542C3.00166 11.2542 2.20171 11.2519 1.40177 11.256C1.23673 11.2566 1.06581 11.2583 0.90841 11.3C0.304046 11.4597 -0.0595124 12.0217 0.00803072 12.6641C0.0691132 13.2471 0.567758 13.7239 1.17506 13.7374C1.97618 13.755 2.7773 13.7503 3.57842 13.741C3.77459 13.7386 3.84624 13.802 3.88089 13.994C4.54164 17.6792 7.32559 20.463 11.0058 21.1178C11.199 21.1518 11.2613 21.2246 11.259 21.4202C11.2496 22.2211 11.2454 23.0226 11.2625 23.8235C11.2748 24.4177 11.7376 24.9133 12.3068 24.9879C12.9352 25.0695 13.4979 24.7331 13.6793 24.1441C13.7328 23.9709 13.7422 23.7795 13.7434 23.5963C13.7498 22.7965 13.7463 21.9968 13.7463 21.1806C13.8591 21.1565 13.9525 21.1324 14.047 21.1166C17.5898 20.5271 20.5235 17.59 21.1144 14.0299C21.1496 13.8173 21.2154 13.7357 21.4445 13.7398C22.2256 13.7539 23.0079 13.7556 23.7891 13.7398C24.5115 13.7251 25.026 13.1567 24.999 12.4362C24.9743 11.7809 24.4586 11.2689 23.7803 11.2589ZM11.2543 6.41524C11.2543 6.68417 11.2531 6.9531 11.2543 7.22203V8.10809C9.78299 8.53791 8.62888 9.70817 8.22303 11.1891H6.42874C6.32126 9.4134 9.28728 6.45164 11.2543 6.41524ZM11.2543 17.6375C11.2478 17.9364 11.2496 18.2353 11.2454 18.5341C11.2454 18.5506 11.2278 18.5664 11.2178 18.5829C9.08289 18.2963 6.8105 16.2265 6.41582 13.8032H8.30409C8.76925 15.1584 9.87167 16.2159 11.2543 16.6199V17.6375ZM12.5 14.7773C11.1245 14.7773 10.0097 13.6629 10.0097 12.2877C10.0097 10.9125 11.1245 9.79801 12.5 9.79801C13.8755 9.79801 14.9903 10.9125 14.9903 12.2877C14.9903 13.6629 13.8755 14.7773 12.5 14.7773ZM13.7422 18.5981C13.7422 18.2065 13.7563 17.8219 13.7393 17.4379C13.7346 17.3345 13.7181 17.2359 13.6917 17.1425V16.6352C15.0995 16.2435 16.2243 15.1754 16.6953 13.8032H18.5748C18.2693 15.9746 16.169 18.2182 13.7416 18.5976L13.7422 18.5981ZM16.7769 11.1891C16.3658 9.68997 15.1882 8.50914 13.6917 8.09282V7.80745C13.7257 7.67769 13.7445 7.53735 13.7457 7.3882C13.7475 7.15392 13.7457 6.91904 13.7457 6.68475C13.7457 6.59844 13.7457 6.51154 13.7457 6.42698C15.5706 6.32011 18.5254 9.24371 18.5795 11.1896H16.7763L16.7769 11.1891Z" fill="#41C6FF"/>
              </svg>
            </div>
          </Tooltip> */}
          <Tooltip placement="bottom" title="Comentarios">
            <div
              onClick={() => this.props.showOrHideViews(1)}
              className={isShowComments ? 'active' : ''}
            >
              <svg
                width={23}
                height={23}
                viewBox="0 0 23 23"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M3.65516 2.33398C3.33662 2.33398 3.03113 2.46052 2.80588 2.68577C2.58064 2.91101 2.4541 3.2165 2.4541 3.53504V18.7293L5.14911 16.0343C5.33665 15.8467 5.591 15.7414 5.85622 15.7414H19.0626C19.3811 15.7414 19.6866 15.6149 19.9118 15.3896C20.1371 15.1644 20.2636 14.8589 20.2636 14.5403V3.53504C20.2636 3.2165 20.1371 2.91101 19.9118 2.68577C19.6866 2.46052 19.3811 2.33398 19.0626 2.33398H3.65516ZM1.39167 1.27155C1.99198 0.671238 2.80619 0.333984 3.65516 0.333984H19.0626C19.9115 0.333984 20.7257 0.671238 21.3261 1.27155C21.9264 1.87187 22.2636 2.68607 22.2636 3.53504V14.5403C22.2636 15.3893 21.9264 16.2035 21.3261 16.8038C20.7257 17.4041 19.9115 17.7414 19.0626 17.7414H6.27043L2.16121 21.8506C1.87521 22.1366 1.44509 22.2222 1.07142 22.0674C0.697744 21.9126 0.454102 21.548 0.454102 21.1435V3.53504C0.454102 2.68607 0.791355 1.87187 1.39167 1.27155Z"
                  fill="#0096D6"
                />
              </svg>
            </div>
          </Tooltip>
          {shouldShowVersionsButton && (
            <Tooltip placement="bottom" title="Comparar versiones">
              <div
                onClick={() => this.props.showOrHideViews(3)}
                className={isShowCompareVersion ? 'active' : ''}
              >
                <svg
                  width="20"
                  height="24"
                  viewBox="0 0 20 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19.3846 5.07692V18.9231C19.3846 19.6575 19.0929 20.3619 18.5735 20.8812C18.0542 21.4006 17.3498 21.6923 16.6154 21.6923H13.3846C13.1398 21.6923 12.905 21.5951 12.7319 21.4219C12.5588 21.2488 12.4615 21.014 12.4615 20.7692C12.4615 20.5244 12.5588 20.2896 12.7319 20.1165C12.905 19.9434 13.1398 19.8462 13.3846 19.8462H16.6154C16.8602 19.8462 17.095 19.7489 17.2681 19.5758C17.4412 19.4027 17.5385 19.1679 17.5385 18.9231V5.07692C17.5385 4.83211 17.4412 4.59732 17.2681 4.42421C17.095 4.2511 16.8602 4.15385 16.6154 4.15385H13.3846C13.1398 4.15385 12.905 4.05659 12.7319 3.88348C12.5588 3.71037 12.4615 3.47558 12.4615 3.23077C12.4615 2.98595 12.5588 2.75117 12.7319 2.57806C12.905 2.40494 13.1398 2.30769 13.3846 2.30769H16.6154C17.3498 2.30769 18.0542 2.59945 18.5735 3.11878C19.0929 3.63811 19.3846 4.34248 19.3846 5.07692ZM10.6154 0.923077V23.0769C10.6154 23.3217 10.5181 23.5565 10.345 23.7296C10.1719 23.9027 9.93712 24 9.69231 24C9.44749 24 9.2127 23.9027 9.03959 23.7296C8.86648 23.5565 8.76923 23.3217 8.76923 23.0769V21.6923H2.76923C2.03479 21.6923 1.33042 21.4006 0.811089 20.8812C0.291757 20.3619 0 19.6575 0 18.9231V5.07692C0 4.34248 0.291757 3.63811 0.811089 3.11878C1.33042 2.59945 2.03479 2.30769 2.76923 2.30769H8.76923V0.923077C8.76923 0.678262 8.86648 0.443473 9.03959 0.270363C9.2127 0.0972524 9.44749 0 9.69231 0C9.93712 0 10.1719 0.0972524 10.345 0.270363C10.5181 0.443473 10.6154 0.678262 10.6154 0.923077ZM8.76923 19.8462V4.15385H2.76923C2.52442 4.15385 2.28963 4.2511 2.11652 4.42421C1.94341 4.59732 1.84615 4.83211 1.84615 5.07692V18.9231C1.84615 19.1679 1.94341 19.4027 2.11652 19.5758C2.28963 19.7489 2.52442 19.8462 2.76923 19.8462H8.76923Z"
                    fill="#0096D6"
                  />
                </svg>
              </div>
            </Tooltip>
          )}
          {/* {(itemSelected.document.type === "image" || itemSelected.document.type === "document") && <Tooltip placement="bottom" title="Ver">
            <div
              onClick={() => {
                this.expandAsset(fromKeyCollection, itemSelected.document)
                this.props.showOrHideViews(1)
              }}
              className={isShowViewFile ? 'active' : ''}
            >
              <svg width="26" height="20" viewBox="0 0 26 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.59766 10.0001C1.59766 10.0001 5.7535 1.61914 13.0262 1.61914C20.299 1.61914 24.4548 10.0001 24.4548 10.0001C24.4548 10.0001 20.299 18.381 13.0262 18.381C5.7535 18.381 1.59766 10.0001 1.59766 10.0001Z" stroke="#0096D6" strokeWidth="2.375" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M13.0256 13.0474C14.7088 13.0474 16.0733 11.6829 16.0733 9.99977C16.0733 8.31661 14.7088 6.95215 13.0256 6.95215C11.3425 6.95215 9.97803 8.31661 9.97803 9.99977C9.97803 11.6829 11.3425 13.0474 13.0256 13.0474Z" stroke="#0096D6" strokeWidth="2.375" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
          </Tooltip>} */}
          {/* <Tooltip placement="bottom" title="Pegar">
            <div
              // onClick={() => this.props.showOrHideViews(2)}
              className={isShowPage ? 'active' : ''}
            >
              <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18.8194 26.7861H5.25272C5.01592 26.7861 4.78882 26.692 4.62138 26.5246C4.45393 26.3572 4.35986 26.1301 4.35986 25.8933V8.56766C4.35986 8.33086 4.45393 8.10376 4.62138 7.93632C4.78882 7.76887 5.01592 7.6748 5.25272 7.6748H18.8194C19.0562 7.6748 19.2833 7.76887 19.4507 7.93632C19.6182 8.10376 19.7122 8.33086 19.7122 8.56766V25.8933C19.7122 26.1301 19.6182 26.3572 19.4507 26.5246C19.2833 26.692 19.0562 26.7861 18.8194 26.7861ZM6.14558 25.0004H17.9265V9.46052H6.14558V25.0004Z" fill="#0096D6"/>
                <path d="M23.6368 21.9687H18.8195C18.5827 21.9687 18.3556 21.8747 18.1882 21.7072C18.0207 21.5398 17.9267 21.3127 17.9267 21.0759C17.9267 20.8391 18.0207 20.612 18.1882 20.4445C18.3556 20.2771 18.5827 20.183 18.8195 20.183H22.7439V4.64314H10.963V8.56695C10.963 8.80375 10.8689 9.03085 10.7014 9.19829C10.534 9.36573 10.3069 9.4598 10.0701 9.4598C9.8333 9.4598 9.6062 9.36573 9.43876 9.19829C9.27131 9.03085 9.17725 8.80375 9.17725 8.56695V3.75028C9.17725 3.51348 9.27131 3.28638 9.43876 3.11893C9.6062 2.95149 9.8333 2.85742 10.0701 2.85742H23.6368C23.8736 2.85742 24.1007 2.95149 24.2681 3.11893C24.4356 3.28638 24.5296 3.51348 24.5296 3.75028V21.0759C24.5296 21.3127 24.4356 21.5398 24.2681 21.7072C24.1007 21.8747 23.8736 21.9687 23.6368 21.9687Z" fill="#0096D6"/>
              </svg>
            </div>
          </Tooltip>
          <Tooltip placement="bottom" title="Copiar">
            <div
              // onClick={() => this.props.showOrHideViews(2)}
              className={isShowCopy ? 'active' : ''}
            >
              <svg width="32" height="31" viewBox="0 0 32 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19.295 26.7861H5.72831C5.49151 26.7861 5.2644 26.692 5.09696 26.5246C4.92952 26.3572 4.83545 26.1301 4.83545 25.8933V8.56766C4.83545 8.33086 4.92952 8.10376 5.09696 7.93632C5.2644 7.76887 5.49151 7.6748 5.72831 7.6748H19.295C19.5318 7.6748 19.7589 7.76887 19.9263 7.93632C20.0938 8.10376 20.1878 8.33086 20.1878 8.56766V25.8933C20.1878 26.1301 20.0938 26.3572 19.9263 26.5246C19.7589 26.692 19.5318 26.7861 19.295 26.7861ZM6.62116 25.0004H18.4021V9.46052H6.62116V25.0004Z" fill="#0096D6"/>
                <path opacity="0.8" d="M13.142 15.8831H17.0005V17.1351H13.142V21H11.8402V17.1351H8.00049V15.8831H11.8402V12H13.142V15.8831Z" fill="#20BCFF"/>
                <path d="M24.1124 21.9687H19.2951C19.0583 21.9687 18.8312 21.8747 18.6637 21.7072C18.4963 21.5398 18.4022 21.3127 18.4022 21.0759C18.4022 20.8391 18.4963 20.612 18.6637 20.4445C18.8312 20.2771 19.0583 20.183 19.2951 20.183H23.2195V4.64314H11.4385V8.56695C11.4385 8.80375 11.3445 9.03085 11.177 9.19829C11.0096 9.36573 10.7825 9.4598 10.5457 9.4598C10.3089 9.4598 10.0818 9.36573 9.91434 9.19829C9.7469 9.03085 9.65283 8.80375 9.65283 8.56695V3.75028C9.65283 3.51348 9.7469 3.28638 9.91434 3.11893C10.0818 2.95149 10.3089 2.85742 10.5457 2.85742H24.1124C24.3492 2.85742 24.5763 2.95149 24.7437 3.11893C24.9111 3.28638 25.0052 3.51348 25.0052 3.75028V21.0759C25.0052 21.3127 24.9111 21.5398 24.7437 21.7072C24.5763 21.8747 24.3492 21.9687 24.1124 21.9687Z" fill="#0096D6"/>
              </svg>
            </div>
          </Tooltip> */}
          {shouldShowVersionsButton && (
            <Tooltip placement="bottom" title="Versiones">
              <div
                onClick={() => this.props.showOrHideViews(2)}
                className={isShowVersions ? 'active' : ''}
              >
                <Badge
                  style={{ backgroundColor: '#0096d6' }}
                  offset={[6, 20]}
                  count={
                    this.props.qtyVersions > 1
                      ? this.props.qtyVersions
                      : undefined
                  }
                >
                  <svg
                    width={26}
                    height={24}
                    viewBox="0 0 26 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13.5976 23.6658C13.345 23.6658 13.1028 23.5654 12.9242 23.3868C12.7456 23.2082 12.6452 22.966 12.6452 22.7134C12.6452 22.4608 12.7456 22.2185 12.9242 22.0399C13.1028 21.8613 13.345 21.761 13.5976 21.761C15.7305 21.7613 17.8018 21.0457 19.4795 19.7287C21.1573 18.4118 22.3444 16.5698 22.8507 14.4979C23.357 12.426 23.1531 10.2441 22.2718 8.30181C21.3905 6.35954 19.8827 4.76933 17.99 3.78598C16.0973 2.80262 13.9294 2.48305 11.8335 2.87847C9.73755 3.27389 7.83504 4.3614 6.43077 5.96677C5.02649 7.57213 4.20175 9.60241 4.08867 11.7323C3.9756 13.8622 4.58075 15.9684 5.80715 17.7134C5.95174 17.9194 6.00887 18.1744 5.96604 18.4224C5.92321 18.6705 5.7839 18.8915 5.57858 19.0372C5.47622 19.1103 5.36039 19.1623 5.23779 19.1904C5.11519 19.2185 4.98825 19.222 4.86428 19.2008C4.74031 19.1795 4.62179 19.1339 4.51554 19.0666C4.40929 18.9993 4.31742 18.9116 4.24525 18.8086C2.77365 16.7147 2.04747 14.1875 2.18305 11.6318C2.31862 9.07608 3.3081 6.63985 4.99296 4.7134C6.67782 2.78695 8.96054 1.48178 11.4754 1.00699C13.9903 0.532206 16.5917 0.915285 18.863 2.09486C21.1342 3.27443 22.9438 5.18221 24.0018 7.51257C25.0599 9.84293 25.3051 12.461 24.6982 14.9473C24.0913 17.4336 22.6674 19.6442 20.6547 21.225C18.642 22.8058 16.1569 23.6653 13.5976 23.6658Z"
                      fill="#0096D6"
                    />
                    <path
                      d="M5.97894 19.8561H1.21703C0.964442 19.8561 0.7222 19.7558 0.543594 19.5772C0.364988 19.3986 0.264648 19.1563 0.264648 18.9037C0.264648 18.6512 0.364988 18.4089 0.543594 18.2303C0.7222 18.0517 0.964442 17.9514 1.21703 17.9514H5.02655V14.1418C5.02655 13.8892 5.12689 13.647 5.3055 13.4684C5.48411 13.2898 5.72635 13.1895 5.97894 13.1895C6.23152 13.1895 6.47376 13.2898 6.65237 13.4684C6.83098 13.647 6.93132 13.8892 6.93132 14.1418V18.9037C6.93132 19.1563 6.83098 19.3986 6.65237 19.5772C6.47376 19.7558 6.23152 19.8561 5.97894 19.8561Z"
                      fill="#0096D6"
                    />
                    <path
                      d="M10.7411 16.0472C10.6158 16.048 10.4915 16.0239 10.3755 15.9766C10.2594 15.9292 10.1539 15.8593 10.0649 15.7711C9.97565 15.6825 9.9048 15.5772 9.85645 15.4611C9.8081 15.3451 9.7832 15.2206 9.7832 15.0949C9.7832 14.9691 9.8081 14.8447 9.85645 14.7286C9.9048 14.6125 9.97565 14.5072 10.0649 14.4187L12.6459 11.8472V7.47582C12.6459 7.22323 12.7462 6.98099 12.9248 6.80238C13.1034 6.62378 13.3457 6.52344 13.5982 6.52344C13.8508 6.52344 14.0931 6.62378 14.2717 6.80238C14.4503 6.98099 14.5506 7.22323 14.5506 7.47582V12.2377C14.5514 12.3631 14.5273 12.4873 14.4799 12.6033C14.4325 12.7194 14.3627 12.8249 14.2744 12.9139L11.4173 15.7711C11.3283 15.8593 11.2228 15.9292 11.1067 15.9766C10.9907 16.0239 10.8664 16.048 10.7411 16.0472Z"
                      fill="#0096D6"
                    />
                  </svg>
                </Badge>
              </div>
            </Tooltip>
          )}

          {/* {info && (
            <Tooltip placement="right" title={info} id={'custom-tooltip'}>
              <div style={{ cursor: 'default', }}>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8 0C3.5888 0 0 3.5888 0 8C0 12.4112 3.5888 16 8 16C12.4112 16 16 12.4112 16 8C16 3.5888 12.4112 0 8 0ZM8 3.28C8.20569 3.28 8.40677 3.34099 8.57779 3.45527C8.74882 3.56955 8.88212 3.73197 8.96083 3.92201C9.03955 4.11204 9.06015 4.32115 9.02002 4.52289C8.97989 4.72463 8.88084 4.90994 8.73539 5.05539C8.58994 5.20084 8.40463 5.29989 8.20289 5.34002C8.00115 5.38014 7.79204 5.35955 7.60201 5.28083C7.41197 5.20212 7.24955 5.06882 7.13527 4.89779C7.021 4.72677 6.96 4.52569 6.96 4.32C6.96 4.04417 7.06957 3.77965 7.26461 3.58461C7.45965 3.38957 7.72418 3.28 8 3.28ZM10.56 11.82C10.56 12.0961 10.3361 12.32 10.06 12.32H6.26C5.98386 12.32 5.76 12.0961 5.76 11.82V11.54C5.76 11.2639 5.98386 11.04 6.26 11.04H7.52V7.52H6.74C6.46386 7.52 6.24 7.29614 6.24 7.02V6.74C6.24 6.46386 6.46386 6.24 6.74 6.24H8.3C8.57614 6.24 8.8 6.46386 8.8 6.74V11.04H10.06C10.3361 11.04 10.56 11.2639 10.56 11.54V11.82Z" fill="#3598CD"/>
                </svg>
              </div>
            </Tooltip>
          )} */}
        </div>
        <Tooltip placement="left" title="Cerrar Dart">
          <a
            style={{
              position: 'absolute',
              top: 50,
              right: 30,
            }}
            onClick={() => this.props.hideComment(intl)}
            href={hash}
          >
            <svg
              width={20}
              height={20}
              viewBox="0 0 33 33"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.4614 12.2165C10.7039 12.4602 11.0226 12.5815 11.3414 12.5815C11.6601 12.5815 11.9788 12.4602 12.2213 12.2165C12.7076 11.7302 12.7076 10.9415 12.2213 10.4553L2.26527 0.489192C1.77903 0.00295153 0.991547 0.00295153 0.505306 0.489192C0.0190648 0.975433 0.0190648 1.76417 0.505306 2.25041L10.4614 12.2165Z"
                fill="white"
              />
              <path
                d="M18.0802 16.3189L32.1362 2.2504C32.6225 1.76416 32.6225 0.975425 32.1362 0.489184C31.65 0.0029427 30.8625 -0.212053 30.3763 0.275438L15.4415 15.0089H15.0716V15.4402L0.321827 30.3874C-0.164413 30.8736 -0.0719153 31.6624 0.413076 32.1486C0.655571 32.3923 1.02056 32.5136 1.33931 32.5136C1.65805 32.5136 1.9993 32.3923 2.24179 32.1486L16.309 18.0814L30.37 32.1498C30.6125 32.3936 30.935 32.5148 31.2525 32.5148C31.57 32.5148 31.8912 32.3936 32.1337 32.1498C32.62 31.6636 32.6212 30.8749 32.135 30.3886L18.0802 16.3189Z"
                fill="white"
              />
            </svg>
          </a>
        </Tooltip>
        {isShowViewFile && <CollectionItemFullScreenV2 
          keyCollection={fromKeyCollection} 
          itemSelected={itemSelected.document} 
          showOrHideViewsFull = {this.showOrHideViewsFull}/>}

      </React.Fragment>
    )
  }
}

const mapStateToProps = (state) => ({
  qtyVersions: state.comments.qtyVersions,
  fromKeyCollection: state.comments.fromKeyCollection
})

const mapDispatchToProps = {
  hideComment,
  setSelectExpandAsset
}

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(RightButtons))
)
